import GeoJSON from 'ol/format/GeoJSON';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Icon, Style } from 'ol/style';
import { zoomToExtent } from './mapHelpers';

const source = new VectorSource({ features: [] });
const style = new Style({
  image: new Icon({
    opacity: 1,
    src: '/map-marker.svg',
    scale: 0.075,
    anchor: [0.5, 1],
  }),
});

const markerLayer = new VectorLayer({ source, style });

export const addAddressMarkerLayerToMap = (map) => map.addLayer(markerLayer);

export const generateGeocodedMarker = (geojson) => {
  const feature = new GeoJSON().readFeature(geojson);
  source.clear();
  source.addFeature(feature);
  const extent = feature.getGeometry().getExtent();
  zoomToExtent(extent);
};

export const removeGeocodedMarker = () => {
  source.clear();
};
